import { colors as commonColors } from 'styles/shared.styles';

export const colors = {
  lineStrokeColor: commonColors.primary,
  lineStrokeColorSecondary: commonColors.purple,
  cartesianGridStrokeColor: 'rgba(49,57,73,0.28)',
  areaChartStopColorPrimary: '#BBDAFD',
  areaChartStopColorSecondary: '#D9D6FD',
};
